import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "BI Dashboards", desc: "Power BI · Tableau · Metabase · Custom React — CEO KPIs, sales performance, marketing attribution, finance, and ads visibility." },
  { title: "Data Engineering", desc: "ETL/ELT pipelines · BigQuery/Snowflake/Redshift warehouses · Scheduled automated reports." },
  { title: "Advanced Analytics", desc: "Customer segmentation · Churn prediction · Sales forecasting · Marketing attribution modelling · Product funnel analytics." },
];

const Analytics = () => (
  <StitchFeaturePage
    label="SERVICE · DATA, ANALYTICS & BI"
    title="Data you have."
    titleAccent="Decisions you need."
    subtitle="Scattered business data into real-time dashboards, AI reports, and predictive models."
    features={features}
    ctaLabel="PLAN YOUR ANALYTICS STACK"
  />
);

export default Analytics;
